module.exports = __webpack_public_path__ + "img/6.358e2fde.png";